module.exports = __webpack_public_path__ + "images/emoji/page_with_curl.f34a670b8ab65857f573.png";